export const UPDATE_CURRENT_PATH = "UPDATE_CURRENT_PATH";

export function updateCurrentPath(area, subArea, subArea2, subArea3) {
  return {
    type: UPDATE_CURRENT_PATH,
    area: area,
    subArea: subArea,
    subArea2: subArea2,
    subArea3: subArea3,
  };
}
